import React, { Dispatch, useEffect, useState } from 'react'
import { Col, Progress, Row, Modal, Button, Input, Spin, message } from "antd"
import { updateBp, deleteBp, updateSku } from '../../api/BPTable/BPTableMethods'
import { LoadingOutlined } from '@ant-design/icons'
import { useUserContext } from "../../userContext"
import { useNavigate } from 'react-router-dom';
import { ProgressBar } from '../inventory/InvetoryTableUtils'

const EditCard = (props: { bpId: string | undefined, referenceId: string | undefined, count: number, bc: number, bl: number, bp: any, setUpdate: Dispatch<boolean> }) => {
  const { bpId, referenceId, count, bc, bl, bp, setUpdate } = props
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [bracelet, setBracelet] = useState<number>(bp?.progression[1])
  const [loading, setLoading] = useState<boolean>(false)
  const [sku, setSku] = useState<string>(bp?.sku)
  const { user } = useUserContext()
  const navigate = useNavigate()

  const getColor = (status: string): string => {
    switch (status) {
      case 'ON_GOING': return "on-going"
      case 'PENDING': return 'waiting'
      case 'COMPLETE': return 'completed'
      case 'TO_DO': return 'to-do'
      default: return 'waiting'
    }
  }

  const handleButton = () => {
    setOpenModal(true)
  }

  useEffect(() => {
    if (bp) {
      setSku(bp?.sku)
    }
  }, [bp])

  const update = async () => {
    setLoading(true)
    if (bracelet === 0 && bp?.progression[0] === 0) {
      await deleteBp(Number(bpId))
      message.success("Le BP " + bpId + " a été supprimé")
      navigate(-1)
    } else
      await updateBp(Number(bpId), bracelet)
    if (sku?.length === 0) {
      message.error("Le SKU ne peut pas être vide")
      setSku(bp?.sku)
    } else if (sku !== bp?.sku) {
      if (count > 0) {
        message.error("Impossible de changer de SKU si le BP est commencé")
      } else {
        const res = await updateSku(Number(bpId), sku)
        console.log(res)
      }
    }
    setUpdate(true)
    setLoading(false)
    setOpenModal(false)
  }

  const ProgresCard = () => (
    <Row justify='space-between'>
      <Col xs={24}>
        <h2>
          <div className={getColor(bp?.status) + "-dot rounded-div"} />
          BP n°{bpId}</h2>
      </Col>
      <Col xs={24}>
        <span>{bp?.sku}</span>
      </Col>
      <Col xs={24}>
        {referenceId}
      </Col>
      <Col xs={16}>
        <ProgressBar percentage={bp?.progression[0] / bp?.progression[1] * 100}
          progress={bp?.progression[0]}
          max={bp?.progression[1]}
          status={bp?.status}
        />
      </Col>
      {user && user.group === 'admin' &&
        <Col style={{ paddingTop: '1rem' }} xs={24}><Button onClick={handleButton}>Edition</Button></Col>
      }
    </Row>
  )

  const EditCard = (props: { text: string, number: number }) => (
    <Row>
      <Col xs={24} className="edit-card-title">
        <h4>{props.text}</h4>
      </Col>
      <Col xs={24} className="edit-card-number">
        <h2 className="edit-card-number">
          {props.number}
        </h2>
      </Col>
    </Row>
  )

  return (
    <>
      <Modal footer={[
        <Button key={"cancel"} onClick={() => { setOpenModal(false); setSku(bp?.sku) }}>Annuler</Button>,
        <Button key={"ok"} style={{ backgroundColor: "#10b981", color: "white" }} onClick={() => update()}>Valider</Button>
      ]} title="Edition du BP" open={openModal} onCancel={() => setOpenModal(false)}>
        <Row className='modal-edit-row' >
          <Col xs={24}>
            <p className='modal-edit-bracelet'>Nombre de bracelets:</p>
            <Spin indicator={<LoadingOutlined />} spinning={loading}>
              <Input allowClear onChange={(e) => { setBracelet(Number(e.target.value)) }} className='modal-edit-number' value={bracelet} defaultValue={bp?.progression[1] ?? 0} type="number"></Input>
            </Spin>
          </Col>
          <Col xs={24}>
            <p className="modal-edit-sku">SKU:</p>
            <Input allowClear onChange={(e) => { setSku(e.target.value) }} className="modal-edit-number" value={sku} defaultValue={bp?.sku ?? ''} />
          </Col>
        </Row>
      </Modal>
      <Row justify={"space-between"}>
        <Col className='edit-card' md={11} lg={6}><ProgresCard /></Col>
        <Col className='edit-card' md={11} lg={3}><EditCard text={count > 1 ? "Plateaux scannés" : "Plateau scanné"} number={count} /></Col>
        <Col className='edit-card' md={11} lg={3}><EditCard text={bl > 1 ? "Bracelets longs" : "Bracelet long"} number={bl} /></Col>
        <Col className='edit-card' md={11} lg={3}><EditCard text={bc > 1 ? "Bracelets courts" : "Bracelet court"} number={bc} /></Col>
      </Row>
    </>
  )
}

export default EditCard